import * as angular from "angular";
import {IController} from "angular";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import * as _ from "lodash";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {GroupModel} from "../../../groups/models/group.model";

export class AgentsItinerariesViewCtrl implements IController {

  branchIds?: any;
  agentSkills?: string[];
  tags?: string[];
  groupIds: string[];
  groupsBranchIds: string[];
  teamIds?: string[];
  agentIds: string[];


  selectedQuickFilterId?: string;

  public hasWorkloadPermission: boolean;
  public hasSelectedAgent: boolean;

  private pageName: string;
  private siteId: string;
  private filtersConfig: any;
  private uiRouterState: any;
  private isMobile: boolean;

  constructor(private $state,
              private IAMPermissions: IAMPermissionsService, private $groups,
              private splitService: SplitService, private $mdMedia, private viewFilterSettingsService: ViewFilterSettingsService) {
    this.pageName = $state.current.name;
  }

  $onInit() {
    this.hasWorkloadPermission = this.IAMPermissions.hasPermission('shiftManagement.workload.service.get');
    this.isMobile = !this.$mdMedia('gt-md');
    this.uiRouterState = this.$state;
    this.siteId = this.splitService.getSiteId();
    this.filtersConfig = {
      queryString: undefined,
      bringozFilters: {
        branchIds: this.branchIds || [],
        [SiteFiltersType.agentSkills]: this.agentSkills || [],
        tags: this.tags || [],
        [SiteFiltersType.groupIds]: this.groupIds || [],
        [SiteFiltersType.teamIds]: this.teamIds || [],
        [SiteFiltersType.agentIds]: this.agentIds || []
      },
      includeFilters: [
        SiteFiltersType.branchIds,
        SiteFiltersType.agentSkills,
        SiteFiltersType.tags,
        SiteFiltersType.groupIds,
        SiteFiltersType.groups,
        SiteFiltersType.teamIds,
        SiteFiltersType.agentIds
      ],
      excludeIdsMap: {
        [SiteFiltersType.branchIds]: this.groupsBranchIds || []
      }
    }
  }

  $doCheck() {
    this.hasSelectedAgent = !!this.$state.params?.agentId;
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      if (quickFilter.settings.groupIds?.length) {
        this.$groups().$asyncValues(quickFilter.settings.groupIds)
          .then((groups) => {
            let groupsBranchIds = [];
            groups.forEach((g: GroupModel) => {
              if (g.branchIds?.length) {
                groupsBranchIds = groupsBranchIds.concat(g.branchIds)
              }
            });
            this.filtersConfig.excludeIdsMap[SiteFiltersType.branchIds] = groupsBranchIds;
            quickFilter.settings[SiteFiltersType.branchIds] = _.uniq(groupsBranchIds);
            this.onFiltersChange(quickFilter.settings, quickFilter);
          })
      } else {
        this.onFiltersChange(quickFilter.settings, quickFilter);
      }
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.filtersConfig.bringozFilters = filters;
    this._setQueryParams();
  }

  onQueryStringChange(queryString) {
    this.filtersConfig.queryString = queryString;
  }

  onBranchesChange(branchIds) {
    if (this.selectedQuickFilterId) {
      this.viewFilterSettingsService.setActiveQuickFilter(undefined, this.pageName);
      this.selectedQuickFilterId = undefined;
    }
    this.filtersConfig.bringozFilters.branchIds = branchIds;

    if (!branchIds?.length) {
      this.filtersConfig.bringozFilters[SiteFiltersType.groupIds] = [];
    }

    this._setQueryParams();
  }

  onAgentTagsChange(tags) {
    if (this.selectedQuickFilterId) {
      this.viewFilterSettingsService.setActiveQuickFilter(undefined, this.pageName);
      this.selectedQuickFilterId = undefined;
    }
    this.filtersConfig.bringozFilters.tags = tags;
    this._setQueryParams();
  }

  onAgentSkillsChange(selectedIds) {
    if (this.selectedQuickFilterId) {
      this.viewFilterSettingsService.setActiveQuickFilter(undefined, this.pageName);
      this.selectedQuickFilterId = undefined;
    }
    this.filtersConfig.bringozFilters.agentSkills = selectedIds;
    this._setQueryParams();
  }

  // onFiltersChange(filters) {
  //   this.filtersConfig.bringozFilters = filters;
  // }

  onStateChangeClicked() {
    const link = this.$state.current.name === 'agents-itinerary.timeline' ? '^.list' : '^.timeline';
    this.$state.go(link);
  }

  private _setQueryParams() {
    this.$state.go('.', {
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      agentSkills: this.filtersConfig.bringozFilters.agentSkills,
      tags: this.filtersConfig.bringozFilters.tags,
      groupIds: this.filtersConfig.bringozFilters.groupIds,
      teamIds: this.filtersConfig.bringozFilters.teamIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      selectedQuickFilterId: this.selectedQuickFilterId
    }, {
      notify: false,
      reload: false
    })
  }

  // ******************************
  //       Responsive Views
  // ******************************

  onToggleMap() {

  };

  // ******************************
  //        Internal methods
  // ******************************

}

angular
  .module('bringoz.admin.agents')
  .component('agentsItinerariesView', {
    bindings: {
      branchIds: '<?',
      agentSkills: '<?',
      tags: '<?',
      selectedQuickFilterId: '<?',
      groupIds: '<?',
      groupsBranchIds: '<?',
      teamIds: '<?',
      agentIds: '<?'
    },
    template: require('./agents-itineraries-view.html').default,
    controller: AgentsItinerariesViewCtrl
  });
